/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useRef, useState } from 'react';
import { Container, Nav } from 'react-bootstrap';
import { Link, NavLink, useMatch } from 'react-router-dom';
import SimpleBar from 'simplebar-react';
import { horizontalMenu } from '../../utils/HorizontalNavInit';
import NavHeader from './NavHeader';
import { useNavigate } from 'react-router-dom';
import { NavMenu } from './NavMenu';
import classNames from 'classnames';
import { ChevronDown } from 'react-feather';

const CompactMenu = () => {

    const [openMenus, setOpenMenus] = useState([]);
    const [openSubMenus, setOpenSubMenus] = useState([]);
    const [desktopHoverMenuId, setDesktopHoverMenuId] = useState(null);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
    const hoverTimerRef = useRef(null);
    const navItemRefs = useRef({});
    let navigate = useNavigate();

    const handleDesktopMouseEnter = (menuId) => {
        clearTimeout(hoverTimerRef.current);
        const el = navItemRefs.current[menuId];
        if (el) {
            const itemRect = el.getBoundingClientRect();
            const menuRect = el.closest('.hk-menu').getBoundingClientRect();
            setDropdownPosition({
                top: itemRect.bottom - menuRect.top,
                left: itemRect.left - menuRect.left,
            });
        }
        setDesktopHoverMenuId(menuId);
    };

    const handleDesktopMouseLeave = (menuId) => {
        hoverTimerRef.current = setTimeout(() => {
            setDesktopHoverMenuId(prev => prev === menuId ? null : prev);
        }, 200);
    };

    const toggleMenu = (id) => {
        setOpenMenus(prev =>
            prev.includes(id) ? prev.filter(m => m !== id) : [...prev, id]
        );
    };

    const toggleSubMenu = (id) => {
        setOpenSubMenus(prev =>
            prev.includes(id) ? prev.filter(m => m !== id) : [...prev, id]
        );
    };

    useEffect(() => {
        setTimeout(() => {
            horizontalMenu();
        }, 300);
        window.dispatchEvent(new Event('resize'));
        const handleWindowResize = () => {
            setTimeout(() => {
                horizontalMenu();
            }, 250);
        };
        window.addEventListener('resize', handleWindowResize);
        return () => {
            window.removeEventListener('resize', handleWindowResize);
        };
    }, [])

    useEffect(() => {
        document.addEventListener("click", function (e) {
            const target = e.target.closest(".more-nav-item");
            const extra = e.target.closest(".extra-link");
            if (target && !extra) {
                e.preventDefault();
                const newTarget = e.target.closest(".nav-link");
                navigate(newTarget.getAttribute("href"));
                // history.push(newTarget.getAttribute("href"));
            }
        });
    }, [history])



    return (
        <div className="hk-menu">
            {/* Brand */}
            <NavHeader />
            {/* Main Menu */}
            <SimpleBar className="nicescroll-bar">
                <div className="menu-content-wrap">
                    <Container fluid className="menu-group">
                        <Nav as="ul" className="navbar-nav flex-column">
                            {
                                NavMenu.map((routes, index) => (
                                    <React.Fragment key={index} >
                                        {
                                            routes.contents.map((menus, ind) => (
                                                // <Nav.Item as='li' key={ind} className={classNames( "text-white-50", { "active": useResolvedPath(menus.path).pathname })} >
                                                <Nav.Item
                                                    as='li'
                                                    key={ind}
                                                    ref={menus.childrens ? el => { navItemRefs.current[menus.id] = el; } : undefined}
                                                    className={classNames("text-white-50", { "active": useMatch(menus.path) })}
                                                    onMouseEnter={menus.childrens ? () => handleDesktopMouseEnter(menus.id) : undefined}
                                                    onMouseLeave={menus.childrens ? () => handleDesktopMouseLeave(menus.id) : undefined}
                                                >
                                                    {
                                                        menus.childrens
                                                            ?
                                                            <>
                                                                <Nav.Link as="div" role="button" onClick={() => toggleMenu(menus.id)} style={{ cursor: 'pointer' }}>
                                                                    <span
                                                                        className={classNames("nav-link-text text-white", { "position-relative": menus.badgeIndicator })}
                                                                    >
                                                                        {menus.name}
                                                                        {menus.badgeIndicator && menus.badgeIndicator}
                                                                    </span>
                                                                    {menus.badge && menus.badge}
                                                                    <ChevronDown size={14} className="ms-auto text-white-50" />
                                                                </Nav.Link>

                                                                <Nav as="ul" id={menus.id} className={classNames("nav flex-column nav-children collapse", { "show": openMenus.includes(menus.id), "desktop-open": desktopHoverMenuId === menus.id })} style={desktopHoverMenuId === menus.id ? { top: dropdownPosition.top, left: dropdownPosition.left } : {}} onMouseEnter={() => handleDesktopMouseEnter(menus.id)} onMouseLeave={() => handleDesktopMouseLeave(menus.id)} onClick={() => setDesktopHoverMenuId(null)}>
                                                                    <Nav.Item as="li">
                                                                        <ul className="nav flex-column">
                                                                            {menus.childrens.map((subMenu, indx) => (
                                                                                subMenu.divider
                                                                                    ?
                                                                                    <li key={indx} className="nav-item"><div style={{ borderTop: '1px solid rgba(255,255,255,0.2)', margin: '4px 16px' }} /></li>
                                                                                    :
                                                                                subMenu.childrens
                                                                                    ?
                                                                                    <Nav.Item as="li" key={indx} >
                                                                                        <Nav.Link as={Link} to="#" className="nav-link" onClick={(e) => { e.preventDefault(); toggleSubMenu(subMenu.id); }}>
                                                                                            <span className="nav-link-text">
                                                                                                {subMenu.name}
                                                                                            </span>
                                                                                        </Nav.Link>

                                                                                        <Nav as="ul" id={subMenu.id} className={classNames("flex-column nav-children collapse", { "show": openSubMenus.includes(subMenu.id) })}>
                                                                                            <Nav.Item as="li">
                                                                                                <ul className="nav flex-column">
                                                                                                    {subMenu.childrens.map((childrenPath, i) => (
                                                                                                        <li className="nav-item" key={i}>
                                                                                                            <Nav.Link as={NavLink} to={childrenPath.path}>
                                                                                                                <span className="nav-link-text">
                                                                                                                    {childrenPath.name}
                                                                                                                </span>
                                                                                                            </Nav.Link>
                                                                                                        </li>
                                                                                                    ))}
                                                                                                </ul>
                                                                                            </Nav.Item>
                                                                                        </Nav>

                                                                                    </Nav.Item>
                                                                                    :
                                                                                    <Nav.Item key={indx}>
                                                                                        <Nav.Link as={NavLink} to={subMenu.path} end>
                                                                                            <span className="nav-link-text">
                                                                                                {subMenu.name}
                                                                                            </span>
                                                                                        </Nav.Link>
                                                                                    </Nav.Item>
                                                                            ))}
                                                                        </ul>
                                                                    </Nav.Item>
                                                                </Nav>
                                                            </>
                                                            :
                                                            <>
                                                                {
                                                                    (routes.group === "Documentation")
                                                                        ?
                                                                        <Nav.Link href={menus.path} target="_blank" className="extra-link" rel="noreferrer" >
                                                                            <span className="nav-link-text">{menus.name}</span>
                                                                            {menus.badge && menus.badge}
                                                                        </Nav.Link>
                                                                        :
                                                                        <Nav.Link as={NavLink} exact={true} activeClassName="active" to={menus.path} >

                                                                            <span className="nav-link-text">{menus.name}</span>
                                                                            {menus.badge && menus.badge}
                                                                        </Nav.Link>
                                                                }
                                                            </>
                                                    }
                                                </Nav.Item>
                                            ))
                                        }
                                    </React.Fragment>
                                ))
                            }
                        </Nav>
                    </Container>
                </div>
            </SimpleBar>
        </div>
    )
}

export default CompactMenu
